// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"msEXS7UmkP4gMiXK"};